export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: "How much notice do you need to get started?",
    answer:
      "At MASA HILLS Health Services, we strive to fill your needs as soon as possible. Call as soon as you think you may have a need, and while the more notice the better, if urgent, we will try to initiate services immediately.",
  },
  {
    question: "Are MASA HILLS Health Services’s Providers licensed, bonded and insured?",
    answer:
      "Yes, all of MASA HILLS Health Services is licensed by the Texas Department of Health and Human Services to provide Personal Assistant Services. All Providers are company employees and are therefore covered under our licensure and insurance.",
  },
  {
    question: "Does insurance cover the cost of this service?",
    answer:
      "MASA HILLS Health Services accepts Long Term Care Insurance, and we will assist with the billing for such plans. However, because Personal Assistance Service does not require the services of a nurse or physical therapist, medical insurance will not cover the cost of care.",
  },
  {
    question: "What services do MASA HILLS Health Services provide?",
    answer:
      "Please click on the Services page for an extensive explanation of the care we can provide. If your need is not listed, please call us and we’ll be happy to discuss whether we can help with any special circumstance.",
  },
  {
    question: "Can MASA HILLS Health Services take my loved one to appointments? Is there an additional cost for this?",
    answer:
      "Our Providers can escort the client to a doctor’s appointment as long as the provider is not the one driving (cannot transport the client), or we can pick up groceries. If you are paying privately for services, yes, we can drive you/your loved one. If the Provider has to use their own car, the cost is $.80 per mile.",
  },
];